var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5b8978af"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 1,
    class: "p-5"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "columns is-mobile" };
const _hoisted_5 = { class: "column" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Citizen", -1));
const _hoisted_7 = { class: "columns is-mobile" };
const _hoisted_8 = { class: "column" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Partner", -1));
const _hoisted_10 = { class: "column" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Site", -1));
const _hoisted_12 = { class: "columns is-mobile" };
const _hoisted_13 = { class: "column" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Case Worker", -1));
const _hoisted_15 = { key: 2 };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "notification bulmaNotification is-info" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "This application is archived, and detailed information has been purged to protect the privacy of the citizen.")
], -1));
const _hoisted_18 = [
    _hoisted_17
];
const _hoisted_19 = { key: 1 };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "notification bulmaNotification is-info" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "This application was submitted via the SSA.gov online portal, and so we do not have the ability to see its content.")
], -1));
const _hoisted_21 = [
    _hoisted_20
];
const _hoisted_22 = { key: 2 };
const _hoisted_23 = { class: "columns is-mobile" };
const _hoisted_24 = { class: "column" };
const _hoisted_25 = { key: 3 };
const _hoisted_26 = { key: 0 };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "notification bulmaNotification is-info" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "This application is archived, and detailed information has been purged to protect the privacy of the citizen.")
], -1));
const _hoisted_28 = [
    _hoisted_27
];
const _hoisted_29 = { key: 1 };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Attachments", -1));
const _hoisted_31 = { key: 4 };
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Status History", -1));
const _hoisted_33 = { key: 5 };
const _hoisted_34 = { key: 6 };
import { sessionState, isFeatureEnabled } from "@/core/session";
import { notifyNetworkError, notifySuccess, notifyError } from "@/core/utils";
import { isEntityManagedByMe } from "@/core/model";
import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { apiSocialSecurity } from "./api";
import { useAsync } from "@/composables/useAsync";
import { offlineStatusTransitions, onlineStatusTransitions } from "./model";
import CitizenChecksBanner from "@/features/citizens/checks/CitizenChecksBanner.vue";
import ApplicationHeaderSection from "@/features/applications/ApplicationHeaderSection.vue";
import ApplicationStatusHistory from "@/features/applications/ApplicationStatusHistory.vue";
import ApplicationSupportDocumentUploadSection from "@/features/applications/ApplicationSupportDocumentUploadSection.vue";
import { doApiAction } from "@/core/api";
import { Citizen, Core, Feature } from "@minicity/core";
import { watchQueryParam } from "@/composables/watchQueryParam";
import { apiCitizens } from "@/features/citizens/api";
var Tab;
(function (Tab) {
    Tab["DETAILS"] = "Citizen Details";
    Tab["FORM"] = "Form Data";
    Tab["ATTACHMENTS"] = "Attachments";
    Tab["STATUS_HISTORY"] = "Status History";
    Tab["COMMENTS"] = "Comments";
    Tab["TASKS"] = "Tasks";
})(Tab || (Tab = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'SocialSecurityDetailPanel',
    props: {
        applicationId: {}
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const application = useAsync();
        // Tabs
        const activeTab = ref(Tab.DETAILS);
        watch(activeTab, watchQueryParam(activeTab, 'tab'));
        const inProgressAction = ref(null);
        const formDataString = ref("");
        const statusTransitions = computed(() => {
            if (!application.data || !isEntityManagedByMe(Core.EntityType['Social Security']))
                return {};
            return application.data.isOnlineApplication ? onlineStatusTransitions : offlineStatusTransitions;
        });
        const loadApplication = () => {
            application.fetch(apiSocialSecurity.getRequest(props.applicationId), "Failed to load request")
                .then((req) => populateFormDataJson());
        };
        onMounted(() => {
            if (!sessionState.session)
                return; // We should only be here if we're logged-in
            loadApplication();
            if (new URL(window.location.toString()).searchParams.has('taskId')) {
                activeTab.value = Tab.TASKS;
            }
        });
        const populateFormDataJson = () => {
            formDataString.value = JSON.stringify(application.data.formData, undefined, 2);
        };
        const saveSocialSecurityForm = () => {
            let formData;
            try {
                formData = JSON.parse(formDataString.value);
            }
            catch (e) {
                notifyError("Invalid form data: " + e);
                return;
            }
            doApiAction(inProgressAction, "saveForm", null, null, () => __awaiter(this, void 0, void 0, function* () {
                yield apiSocialSecurity.updateForm(application.data.id, formData)
                    .then(resp => {
                    if (resp.errorMessage) {
                        notifyError(resp.errorMessage);
                    }
                    else {
                        application.data.formData = resp.formData;
                        populateFormDataJson();
                        notifySuccess("Form updated");
                    }
                })
                    .catch((err) => {
                    notifyNetworkError("Failed to update form", err);
                });
            }));
        };
        const uploadKeyDocument = (file) => {
            return apiCitizens.uploadAttachment(application.data.citizen.id, Citizen.AttachmentType.SOCIAL_SECURITY, file)
                .then(doc => { application.data.keyDocumentAttachments.push(doc); });
        };
        const deleteKeyDocument = (id) => {
            return apiCitizens.deleteAttachment(application.data.citizen.id, id)
                .then(() => { application.data.keyDocumentAttachments = application.data.keyDocumentAttachments.filter((d) => d.id != id); });
        };
        const getAttachmentViewLink = (id) => {
            return apiCitizens.getAttachmentViewLink(application.data.citizen.id, id);
        };
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            const _component_TabsHeader = _resolveComponent("TabsHeader");
            const _component_CitizenBadge = _resolveComponent("CitizenBadge");
            const _component_router_link = _resolveComponent("router-link");
            const _component_PartnerBadge = _resolveComponent("PartnerBadge");
            const _component_SiteBadge = _resolveComponent("SiteBadge");
            const _component_UserBadge = _resolveComponent("UserBadge");
            const _component_FormCodeEditorField = _resolveComponent("FormCodeEditorField");
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_CommentSection = _resolveComponent("CommentSection");
            const _component_TaskSection = _resolveComponent("TaskSection");
            return (_unref(isFeatureEnabled)('SOCIAL_SECURITY'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_unref(application).status == 'loading')
                        ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                        : (_unref(application).status == 'ready')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (_unref(isFeatureEnabled)(_unref(Feature).Type.EQUIFAX_CHECKS))
                                    ? (_openBlock(), _createBlock(CitizenChecksBanner, {
                                        key: 0,
                                        citizenId: _unref(application).data.citizen.id
                                    }, null, 8, ["citizenId"]))
                                    : _createCommentVNode("", true),
                                _createVNode(ApplicationHeaderSection, {
                                    underlyingApplication: _unref(application).data,
                                    applicationTypeName: "Social Security",
                                    title: `Social Security Request #${_unref(application).data.id}`,
                                    createdAt: _unref(application).data.createdAt,
                                    status: _unref(application).data.status,
                                    statusTransitions: statusTransitions.value,
                                    setStatus: _unref(application).data.isArchived ? undefined : (status) => _unref(apiSocialSecurity).setStatus(_ctx.applicationId, status).then(loadApplication),
                                    statusMessage: _unref(application).data.statusMessage,
                                    setStatusMessage: (message, notifyCitizen) => _unref(apiSocialSecurity).setStatusMessage(_ctx.applicationId, message, notifyCitizen).then(() => _unref(application).data.statusMessage = message),
                                    deleteStatusMessage: () => _unref(apiSocialSecurity).deleteStatusMessage(_ctx.applicationId).then(() => _unref(application).data.statusMessage = undefined),
                                    keyDocumentAttachments: _unref(application).data.keyDocumentAttachments,
                                    uploadKeyDocument: uploadKeyDocument,
                                    deleteKeyDocument: deleteKeyDocument,
                                    getAttachmentViewLink: getAttachmentViewLink,
                                    statusReport: _unref(application).data.statusReport,
                                    fulfillment: _unref(application).data.fulfillment,
                                    clone: () => _unref(apiSocialSecurity).clone(_ctx.applicationId).then((newId) => _unref(router).push(newId)),
                                    getPdfViewLink: (_unref(application).data.isArchived || _unref(application).data.isOnlineApplication) ? undefined : () => _unref(apiSocialSecurity).getPdfViewLink(_ctx.applicationId)
                                }, null, 8, ["underlyingApplication", "title", "createdAt", "status", "statusTransitions", "setStatus", "statusMessage", "setStatusMessage", "deleteStatusMessage", "keyDocumentAttachments", "statusReport", "fulfillment", "clone", "getPdfViewLink"]),
                                _createVNode(_component_TabsHeader, {
                                    modelValue: activeTab.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((activeTab).value = $event)),
                                    tabs: Tab,
                                    entityType: _unref(Core).EntityType['Social Security'],
                                    entityId: _unref(application).data.id
                                }, null, 8, ["modelValue", "entityType", "entityId"]),
                                (activeTab.value == Tab.DETAILS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _hoisted_6,
                                                _createVNode(_component_router_link, {
                                                    to: `/citizens/${_unref(application).data.citizen.id}`
                                                }, {
                                                    default: _withCtx(() => [
                                                        (_unref(application).data.citizen)
                                                            ? (_openBlock(), _createBlock(_component_CitizenBadge, {
                                                                key: 0,
                                                                citizen: _unref(application).data.citizen
                                                            }, null, 8, ["citizen"]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                }, 8, ["to"])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _hoisted_9,
                                                _createVNode(_component_PartnerBadge, {
                                                    partner: _unref(application).data.citizen.assignedCareProvider
                                                }, null, 8, ["partner"])
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                _hoisted_11,
                                                _createVNode(_component_SiteBadge, {
                                                    site: _unref(application).data.citizen.assignedSite
                                                }, null, 8, ["site"])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("div", _hoisted_13, [
                                                _hoisted_14,
                                                _createVNode(_component_UserBadge, {
                                                    user: _unref(application).data.citizen.assignedCaseworker
                                                }, null, 8, ["user"])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.FORM)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        (_unref(application).data.isArchived)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                                            : (_unref(application).data.isOnlineApplication)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _createElementVNode("div", _hoisted_24, [
                                                            _createVNode(_component_FormCodeEditorField, {
                                                                modelValue: formDataString.value,
                                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((formDataString).value = $event)),
                                                                language: "json"
                                                            }, null, 8, ["modelValue"])
                                                        ])
                                                    ]),
                                                    _createVNode(_component_SaveButton, {
                                                        label: "Save Form",
                                                        icon: "fa-save",
                                                        action: "saveForm",
                                                        inProgressAction: inProgressAction.value,
                                                        onClick: _cache[2] || (_cache[2] = ($event) => (saveSocialSecurityForm()))
                                                    }, null, 8, ["inProgressAction"])
                                                ]))
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.ATTACHMENTS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        (_unref(application).data.isArchived)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                _hoisted_30,
                                                _createVNode(ApplicationSupportDocumentUploadSection, {
                                                    title: "Cover Pages",
                                                    documents: _unref(application).data.coverPages,
                                                    upload: (file) => _unref(apiSocialSecurity).uploadCoverPage(_ctx.applicationId, file).then((doc) => _unref(application).data.coverPages.push(doc)),
                                                    delete: (id) => _unref(apiSocialSecurity).deleteAttachment(_ctx.applicationId, id).then(() => _unref(application).data.coverPages = _unref(application).data.coverPages.filter(d => d.id != id)),
                                                    getViewLink: (id) => _unref(apiSocialSecurity).getAttachmentViewLink(_ctx.applicationId, id)
                                                }, null, 8, ["documents", "upload", "delete", "getViewLink"]),
                                                _createVNode(ApplicationSupportDocumentUploadSection, {
                                                    title: "Supporting ID / Documentation",
                                                    documents: _unref(application).data.supportDocuments,
                                                    upload: (file) => _unref(apiSocialSecurity).uploadSupportingDocument(_ctx.applicationId, file).then((doc) => _unref(application).data.supportDocuments.push(doc)),
                                                    delete: (id) => _unref(apiSocialSecurity).deleteAttachment(_ctx.applicationId, id).then(() => _unref(application).data.supportDocuments = _unref(application).data.supportDocuments.filter(d => d.id != id)),
                                                    getViewLink: (id) => _unref(apiSocialSecurity).getAttachmentViewLink(_ctx.applicationId, id)
                                                }, null, 8, ["documents", "upload", "delete", "getViewLink"])
                                            ]))
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.STATUS_HISTORY)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        _hoisted_32,
                                        _createVNode(ApplicationStatusHistory, {
                                            statusHistory: _unref(application).data.statusHistory
                                        }, null, 8, ["statusHistory"])
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.COMMENTS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createVNode(_component_CommentSection, {
                                            getComments: () => _unref(apiSocialSecurity).getComments(_unref(application).data.id),
                                            addComment: (message, attachments, notifyCaseworker) => _unref(apiSocialSecurity).addComment(_unref(application).data.id, message, attachments, notifyCaseworker),
                                            getAttachmentViewLink: (commentId, attachmentId) => _unref(apiSocialSecurity).getCommentAttachmentViewLink(_unref(application).data.id, commentId, attachmentId)
                                        }, null, 8, ["getComments", "addComment", "getAttachmentViewLink"])
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.TASKS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                        _createVNode(_component_TaskSection, {
                                            allowShowAll: "",
                                            getTasks: () => _unref(apiSocialSecurity).getTasks(_unref(application).data.id),
                                            addTask: (audience, message) => _unref(apiSocialSecurity).addTask(_unref(application).data.id, audience, message)
                                        }, null, 8, ["getTasks", "addTask"])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
